// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_ez-3";
export var flatBottomCorners = "_ez-5";
export var productImage = "_ez-0";
export var quantityContainer = "_ez-2";
export var quantityHeader = "_ez-6";
export var tooltip = "_ez-1";
export var wrapAndEllipsesOverflow = "_ez-4";